'use strict';

(function () {
  angular
    .module('specsguardApp')
    .directive('widgetProjectTeam', widgetProjectTeam);

  function widgetProjectTeam () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/team/widget-project-team.tmpl.html',
      controller: 'widgetProjectTeam',
      controllerAs: '$widgetProjectTeam',
      scope: true,
    };
  }

})();
